import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postDemoTopUp } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useDemoTopUp() {
  const getToken = useAccountGetToken();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (amount: number) => postDemoTopUp(getToken, amount),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['account', 'wallet'] });
      void qc.invalidateQueries({ queryKey: ['account', 'leads'] });
    }
  });
}
